export default {
  title: 'Já pode fechar esta página. Se tiver alguma dúvida, ligue-nos para',
  'call-rating': 'Avaliação da chamada',
  comment: {
    title: 'Deixe os seus comentários:',
    placeholder: 'Diga-nos se gostou de tudo, quais eram as suas expectativas e impressões',
    error: 'Deu uma avaliação baixa — pode explicar o que correu mal?',
    'send-btn': 'Enviar',
  },
  'accepted-message': 'O seu comentário foi recebido. Obrigado por utilizar o nosso serviço de entregas!',
  'rate-thanks': 'Obrigado pelo seu comentário!',
  'rate-prompt': 'Avalie a nossa chamada!',
}
